import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=274436fe&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"
import style0 from "./Features.vue?vue&type=style&index=0&id=274436fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274436fe",
  null
  
)

export default component.exports